const standardizePhoneNumber = num => {
  let n; //n is the number input
  let numsOutput = '';
  if (num) {
    n = num.replace(/[^\d]/g, '').split('');
    const numsOnly = [];
    for (let i = 0; i < num.length; i = 1 + i) {
      if (Number.isInteger(n[i])) {
        numsOnly.push(n[i]);
      }
    }
    n = n.join('');

    if (n.length === 10) {
      numsOutput =
        `(${n[0]}${n[1]}${n[2]})` +
        ` ` +
        ` ${n[3]}${n[4]}${n[5]}-${n[6]}${n[7]}${n[8]}${n[9]}`;
    } else if (n.length > 10) {
      numsOutput = `${`(${n[0]}${n[1]}${n[2]})` +
        ` ` +
        ` ${n[3]}${n[4]}${n[5]}-${n[6]}${n[7]}${n[8]}${n[9]}` +
        ' '}${n.slice(10, n.length)}`;
    } else if (n.length >= 3) {
      numsOutput = `(${`${n[0]}${n[1]}${n[2]}) ` +
        ` ` +
        ` ${n.slice(3, n.length)}`}`;
    } else if (n.length >= 0) {
      numsOutput = `(${n.slice(0, n.length)})`;
    } else {
      return '';
    }
  } else {
    numsOutput = num;
  }
  return numsOutput || null;
};

module.exports = { standardizePhoneNumber };
